export const siteConfig = {
  name: "NLC Construction",
  legalName: "NLC Group",
  domain: "nlcconstruction.co.uk",
  baseUrl: "https://www.nlcconstruction.co.uk",
  phone: "07725 795516",
  email: "contact@nlcgroupuk.com",
  address: {
    street: "",
    locality: "Leeds",
    region: "West Yorkshire",
    country: "UK",
    postalCode: ""
  },
  geo: { lat: 53.8008, lng: -1.5491 },
  hours: "Mon-Fri 8am-6pm, Sat 9am-2pm",
  social: {
    facebook: "https://www.facebook.com/nlcgroupuk",
    instagram: "https://www.instagram.com/nlcgroupuk"
  }
};

// Helper to track phone clicks
export const trackPhoneClick = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'phone_click', {
      'event_category': 'Contact',
      'event_label': siteConfig.phone
    });
  }
};

// Helper to track email clicks
export const trackEmailClick = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'email_click', {
      'event_category': 'Contact',
      'event_label': siteConfig.email
    });
  }
};
